import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIList from 'UIComponents/list/UIList';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import TrialRedirectButton from './tx-120/TrialRedirectButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ActivationSuccessFooter = ({
  ctaText,
  showTrialLoadingState,
  onSuccess = () => {},
  upgradeData,
  featureName
}) => {
  return /*#__PURE__*/_jsx(UIDialogFooter, {
    align: "center",
    children: /*#__PURE__*/_jsx(UIList, {
      firstChildClassName: "m-bottom-3",
      style: {
        maxWidth: '450px'
      },
      children: showTrialLoadingState ? /*#__PURE__*/_jsx(UILoadingSpinner, {
        showLabel: true,
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.activationModal.loadingLabel"
        })
      }) : /*#__PURE__*/_jsxs(UIFlex, {
        direction: "column",
        justify: "center",
        align: "center",
        gap: 12,
        style: {
          textAlign: 'center'
        },
        children: [featureName ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "upgrades.activationModal.headBackToFeature",
          options: {
            featureName
          }
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.activationModal.trialStartSubtitle"
        }), /*#__PURE__*/_jsx(TrialRedirectButton, {
          block: true,
          use: "primary",
          onClick: onSuccess,
          buttonText: ctaText,
          upgradeData: upgradeData,
          style: {
            maxWidth: '70%'
          }
        })]
      })
    })
  });
};
export default ActivationSuccessFooter;